import t from "../../../../i18n";
import type { BlockDiagramModelT } from "../../Dashboards/schema/block/diagram";
import type { DashboardBlockModelT } from "../../Dashboards/schema/dashboard";

const createBaseBlock = (position: [number, number, number, number]) => ({
  id: globalThis.crypto.randomUUID(),
  dashboardId: "",
  timestamp: Date.now(),
  position,
});

export const plantStateBlockDashboardTemplate = [
  {
    ...createBaseBlock([1, 1, 3, 1]),
    kind: "PRESET",
    data: {
      title: t("project.dashboard.block.template.average-losses-preset.title"),
      preset: "AVERAGE_LOSSES",
    },
  },
  {
    ...createBaseBlock([4, 1, 3, 1]),
    kind: "PRESET",
    data: {
      title: t("project.dashboard.block.template.production-monitoring-preset.title"),
      preset: "PRODUCTION_MONITORING",
    },
  },
  {
    ...createBaseBlock([1, 2, 6, 1]),
    kind: "DIAGRAM",
    data: {
      title: "",
      period: "P1M",
    },
    config: {
      url: "",
      live: true,
      show_all: true,
      show_role: false,
      aggregate: true,
      layers: [] as BlockDiagramModelT["config"]["layers"],
    },
  },
  {
    ...createBaseBlock([1, 3, 6, 1]),
    kind: "PRESET",
    data: {
      title: t("project.dashboard.block.template.priority-fault-events-preset.title"),
      preset: "PRIORITY_FAULT_EVENTS",
      systemIds: [],
    },
  },
  {
    ...createBaseBlock([1, 4, 6, 1]),
    kind: "COMMENT",
    data: "",
  },
] satisfies DashboardBlockModelT[];
